// Native JS utilities to replace lodash
// Replace lodash cloneDeep with structuredClone (native)
const cloneDeep = (obj)=>{
    if (typeof structuredClone !== 'undefined') {
        return structuredClone(obj);
    }
    // Fallback for environments without structuredClone
    return JSON.parse(JSON.stringify(obj));
};
// Replace lodash keyBy with native reduce
const keyBy = (array, key)=>{
    return array.reduce((acc, item)=>{
        const keyValue = item[key];
        acc[keyValue] = item;
        return acc;
    }, {});
};
// Safe JSON parse utility
const safeParse = (jsonString, fallback)=>{
    try {
        if (!jsonString) return fallback;
        return JSON.parse(jsonString);
    } catch (error) {
        return fallback;
    }
};

export { cloneDeep, keyBy, safeParse };
//# sourceMappingURL=utils.js.map
